export const prepareNotification = (type: any, labelsMap: any, t: Function) => ((msg: any) => {
    if (msg.field) {
        return { type, msg: `${t(labelsMap[msg.field])}: ${t(msg.key, msg.options)}` }
    } else {
        return { type, msg: t(msg.key, msg.options)}
    }
})
